import { Modal, Button } from 'antd';
import React from 'react';
import './index.scss';
import { fetch } from '../../../Utilitys/ApiRequest';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, connect } from 'react-redux';
import { hideLegalModal, showRegisterSuccessModal, fetchLogin } from '../../../Actions/Authentication';

const LegalModal = ({ legalModal }) => {
   const { visible, providerType, payload } = legalModal;
   const dispatch = useDispatch();
   const contentRef = useRef(null);
   const [policyDescription, setPolicyDescription] = useState();
   const [isEndScroll, setIsEndScroll] = useState(false);

   console.log(legalModal);

   const modalConfig = {
      visible: visible,
      width: 900,
      footer: null,
      onCancel: () => dispatch(hideLegalModal()),
      className: 'legal-modal',
      style: { top: 16 },
      afterClose: () => dispatch(showRegisterSuccessModal())
   };

   const fetchPolicyDescription = async () => {
      try {
         const response = await fetch('get', 'applications/legal');
         setPolicyDescription(response.data);
      } catch (error) {
         console.log(error);
      }
   };

   const handleEndScroll = () => {
      if (
         contentRef.current.scrollTop + contentRef.current.clientHeight >= contentRef.current.scrollHeight &&
         !isEndScroll
      ) {
         setIsEndScroll(true);
      } else {
         setIsEndScroll(false);
      }
   };

   const handleAcceptPolicy = () => {
      dispatch(fetchLogin(providerType, payload));
      dispatch(hideLegalModal());
   };

   useEffect(() => {
      if (visible) {
         fetchPolicyDescription();
      }
   }, [visible]);

   return (
      <Modal {...modalConfig}>
         <div className='title-container'>
            <h1>นโยบายความเป็นส่วนตัว & เงื่อนไขการใช้บริการ</h1>
            <p>กรุณาเลื่อนลงเพื่ออ่านข้อมูลทั้งหมด ก่อนกดยอมรับ</p>
         </div>
         <div ref={contentRef} className='legal-modal-content' onScroll={handleEndScroll}>
            {policyDescription && (
               <>
                  <div dangerouslySetInnerHTML={{ __html: policyDescription.privacy }} />
                  <div dangerouslySetInnerHTML={{ __html: policyDescription.termOfUse }} />
               </>
            )}
         </div>
         <div className='footer-container'>
            <Button
               shape='round'
               disabled={!isEndScroll}
               onClick={() => {
                  handleAcceptPolicy();
               }}
            >
               ยอมรับ
            </Button>
         </div>
      </Modal>
   );
};

const mapStateToProps = (state) => {
   return {
      legalModal: state.Authentication.legalModal
   };
};

export default connect(mapStateToProps)(LegalModal);
